import { AxiosInstance } from 'axios';
import { createContextAwareHandlers } from './instance';

interface BillResponse {
  count: number;
  items: Bill[];
  limit: number;
  offset: number;
  totalCount: number;
}

interface AuthorizeBillResponse {
  paymentIntentId: string;
  clientSecret: string;
  paymentMethodId: string;
}

export const getBills = (instance: AxiosInstance) => async (id: string, isConnectContext?: boolean): Promise<Bill[]> => {
  const { data } = await instance.get<BillResponse>(`/${isConnectContext ? 'partnerships' : 'customers'}/${id}/bills`);

  return data ? data.items : [];
};

export const getBillsRequiresAction = (instance: AxiosInstance) => async (customerId: string, isConnectContext?: boolean): Promise<Bill[]> => {
  const { data } = await instance.get<BillResponse>(`/${isConnectContext ? 'partnerships' : 'customers'}/${customerId}/bills?requiresaction=true`);

  return data ? data.items : [];
};

export const downloadBill = (instance: AxiosInstance) => async (customerId: string, billId: string, isConnectContext?: boolean): Promise<Blob> => {
  const { data } = await instance.get<Blob>(`/${isConnectContext ? 'partnerships' : 'customers'}/${customerId}/bills/${billId}/download`, {
    responseType: 'blob',
  });
  return data;
};

export const authorizeBill = (instance: AxiosInstance) => async (
  customerId: string,
  billId: string,
  isConnectContext?: boolean,
): Promise<AuthorizeBillResponse> => {
  const { data } = await instance.post<AuthorizeBillResponse>(
    `/${isConnectContext ? 'partnerships' : 'customers'}/${customerId}/bills/${billId}/retry`,
  );
  return data;
};

const handlers = {
  getBills,
  getBillsRequiresAction,
  downloadBill,
  authorizeBill,
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createBillingApi = (context: PortalContext) => {
  return createContextAwareHandlers(context, handlers);
};

export default createBillingApi;
